export default "__VITE_ASSET__eFqh1AZy__"